// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609160926/js/" + chunkId + "." + {"44":"33a6543c","225":"ff16e964","481":"f96b22c9","486":"2638bb2a","770":"6d430ace"}[chunkId] + ".0.11568725932003965.chunk.js";
};